/**
 * La marca, y NADA MAS.
 *
 * Vivia en `piezas.tsx`, que importa `@vc/audio` en la primera linea. Eso
 * significaba que pedirle el logotipo a `@vc/ui` —que es lo unico que necesita
 * la landing— arrastraba el paquete de audio entero y fft.js detras: trece
 * kilobytes de transformada rapida de Fourier en una pagina de marketing que
 * no graba nada.
 *
 * Este modulo no importa nada. Se puede pedir desde donde sea.
 */

/* ─────────────────────────────────────────────────────────────────────────
   EL ISOTIPO · ondas que se afilan

   15/09/2026: era la glotis abierta vista desde arriba —dos pliegues en forma
   de almendra con el aire en medio— y el dueño la marcó en la captura: «la logo
   se parece a una vagina». Se le enseñaron cuatro opciones y eligió la D:
   cinco barras redondeadas, la del centro la más alta, como la onda de alguien
   hablando. Sin caja y sin degradado, en el color de la marca.

   16/09/2026: la D pasa a la I. El dueño pidió otras ideas, «haciendo tipo la
   punta de una flecha apuntando para la derecha, y la cola de la flecha a la
   izquierda, con las ondas sonoras […] pero tiene que ser auténtico e único»,
   y de cinco (K, H, I, F y G) eligió esta: «nos vamos con la logo adjunta».
   Una barra corta, dos ondas redondas que crecen, y la última ya es una punta:
   la voz que sale y va hacia delante. Mismo trazo redondeado y mismo color;
   las esquinas también redondas, para que la punta no pinche a 16 píxeles.

   Las mismas coordenadas están en `activos/marca/isotipo.svg` (en S3, lo mismo), en
   `scripts/generar-isotipo-correo.py` y en `scripts/generar-tarjeta-social.py`.
   Si cambian aquí, cambian allí.
   ───────────────────────────────────────────────────────────────────────── */

export function Isotipo({ tam = 28 }: { readonly tam?: number }): React.ReactElement {
  return (
    <svg width={tam} height={tam} viewBox="0 0 64 64" role="img" aria-label="Voice Comfort">
      {/* 16/09/2026: eran cinco <line> con strokeWidth 6 (la D): x 8, 20, 32, 44 y 56, de y 27-37,
          17-47, 8-56, 19-45 y 28-36. */}
      <g fill="none" stroke="var(--vc-marca)" strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="7" y1="26" x2="7" y2="38" />
        <path d="M18 22q8 10 0 20" />
        <path d="M30 15q12 17 0 34" />
        <path d="M43 9l15 23-15 23" />
      </g>
    </svg>
  );
}
